import React from 'react';
import FullPageSimulator from '../../FullPageSimulator';
import ManualMethodsList from '../../../../ManulRecipient/ManualMethodsList';

const MenuManualListFP = ({
  globJSON,
  simPlatform,
  recipient,
  slideshowRefs = null,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={recipient.select_recipient_details_type}
    WithGrayBackground={recipient.screens_ordering.filter((manualKey) => recipient.manual_recipients[manualKey].selected).length < 2}
    slideshowRefs={slideshowRefs}
  >
    <ManualMethodsList
      globJSON={globJSON}
      simPlatform={simPlatform}
      recipient={recipient}
    />
  </FullPageSimulator>
);

export default MenuManualListFP;
